module.exports = "/components/components/slingTourModal-dc1e85.html";